import * as React from 'react'
import {DemoContainer} from '@mui/x-date-pickers/internals/demo'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {DatePicker} from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import {Stack} from '@mui/material'
import LabelInput from '../customTable/LabelInput'

export default function BasicDatePicker({name, data, setData, placeholder}: any) {
  const handleDateChange = (newDate: any) => {
    if (newDate) {
      const formattedDate = dayjs(newDate).format('YYYY-MM-DD') // تحويل التاريخ إلى Y-m-d
      setData({...data, [name]: formattedDate})
    }
  }
  console.log(data)

  return (
    <Stack gap='8px'>
      <LabelInput text={placeholder} />
      <Stack dir='ltr'>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DatePicker
              sx={{
                width: '100%', // عرض العنصر
                // backgroundColor: '#f5f5f5', // لون الخلفية
                borderRadius: '6.18px', // تدوير الحواف
                '& .MuiInputBase-root': {
                  padding: '11.0625px 13px 12.5px', // تعديل الحواف الداخلية
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'var(--bs-gray-300)', // لون الإطار
                },

                '& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input': {
                  padding: '0',
                },
              }}
              value={data[name] ? dayjs(data[name]) : null} // استخدام القيمة الحالية إذا كانت موجودة
              onChange={handleDateChange}
            />
          </DemoContainer>
        </LocalizationProvider>
      </Stack>
    </Stack>
  )
}
